import { FormSection } from "@omnabase/ui";
import { DEFAULT_ACCENT } from "@omnabase/shared";
import { api } from "../../lib/api";
import { useFormState, useSaver } from "../../lib/save";
import { signatureHtml, signatureVarsFor } from "../../lib/signature";
import { useSession } from "../../shell/store";
import { MailMock, SignatureColors, SignatureEditor, SignatureLayout } from "./SignatureBlock";

/** Settings › General's "Signature" (the top bar, signature and reports round, 2026-10-26): the text every reply ends with unless its project
 *  uses its own, an administrator's; the mock-up fills it for the person looking, with the first open project as {project} (question 14).
 *  The logo is the workspace's own, shown whatever its type (question 9; the mail logo round, 2026-10-27: an SVG reaches mail as its PNG copy,
 *  no note). The signature HTML and role round (2026-10-28): the mock-up has no head, and the two colours sit under the editor. */
export function WorkspaceSignatureSection() {
  const { workspace, me, reload, toast } = useSession();
  const [f, setF] = useFormState({ signature: workspace.signature, signatureColor: workspace.signatureColor ?? null, signatureLinkColor: workspace.signatureLinkColor ?? null }, workspace.id);
  const { save } = useSaver<Partial<typeof f>>(async (patch) => { await api.patch(`/api/v1/w/${workspace.slug}/settings`, patch); await reload(); }, (m) => toast(m, { kind: "error" }));
  const change = (patch: Partial<typeof f>) => { setF((prev) => ({ ...prev, ...patch })); save(patch); };
  const first = workspace.projects.find((p) => !p.archivedAt) ?? null;
  const html = signatureHtml(f.signature, signatureVarsFor({ ...workspace, signatureColor: f.signatureColor, signatureLinkColor: f.signatureLinkColor }, me, first, { logo: workspace.logo, workspaceColors: true }));
  return (
    <FormSection title="Signature" intro="The signature every reply ends with, filled in for the person who sends it. A project can use its own instead.">
      <SignatureLayout mock={<MailMock html={html} />}>
        <SignatureEditor value={f.signature} onChange={(v) => change({ signature: v })} />
        <SignatureColors value={f} accent={workspace.settings.accent ?? DEFAULT_ACCENT} onChange={change} />
      </SignatureLayout>
    </FormSection>
  );
}
